// Imagem genérica para o lazyload
function imgLazy(width, height) {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`;
}

// Reinicia o slick para corrigir possíveis bug com lazyload
function slickReinitLazy($carrosel, initFunc, destroyFunc) {
  if ($carrosel.length > 0 && typeof initFunc === 'function' && typeof destroyFunc === 'function') {
    let slickReinit = false;
    doWhenVisible($carrosel, function () {
      if (!slickReinit) {
        //console.log($carrosel.attr('id'));
        $carrosel.find('.lazyload').each(function () {
          lazySizes.loader.unveil($(this)[0]);
        });
        destroyFunc();
        initFunc();
        slickReinit = true;
      }
    });
  }
}

// Gera a lista de parcelas
function gerarParcelas(valor, qtdeParc, qtdeParcSemJuros = 1, juros = 0) {
  const listaParcelas = [];
  qtdeParcSemJuros = !qtdeParcSemJuros || qtdeParcSemJuros < 1 ? 1 : qtdeParcSemJuros;
  for (let parcela = 1; parcela <= qtdeParc; parcela++) {
    let valorParcela = 0;
    let valorTotal = 0;
    let semJuros;
    // Parcelamento sem juros
    if (parcela <= qtdeParcSemJuros || juros === 0) {
      valorParcela = valor / parcela;
      valorTotal = valor;
      semJuros = true;
    }
    // Parcelamento com juros
    else {
      const valorJuros = juros / 100;
      valorParcela = (valor * valorJuros * Math.pow(1 + valorJuros, parcela)) / (Math.pow(1 + valorJuros, parcela) - 1);
      valorTotal = valorParcela * parcela;
      semJuros = false;
    }
    valorParcela = valorParcela.toFixed(2);
    valorTotal = valorTotal.toFixed(2);
    listaParcelas.push({
      num_parcela: parcela,
      valor_parcela: valorParcela,
      valor_total: valorTotal,
      sem_juros: semJuros,
    });
  }
  return listaParcelas;
}

// Gera a lista de parcelas (Mercaod Pago)
function gerarParcelasMP(valor, qtdeParc, qtdeParcSemJuros = 1) {
  const listaParcelas = [];
  qtdeParcSemJuros = !qtdeParcSemJuros || qtdeParcSemJuros < 1 ? 1 : qtdeParcSemJuros;
  for (let parcela = 1; parcela <= qtdeParc; parcela++) {
    let valorParcela = 0;
    let valorTotal = 0;
    let semJuros;
    // Parcelamento sem juros
    if (parcela <= qtdeParcSemJuros) {
      valorParcela = valor / parcela;
      valorTotal = valor;
      semJuros = true;
    }
    // Parcelamento com juros
    else {
      valorParcela = mpCalcParcela(valor, parcela);
      valorTotal = valorParcela * parcela;
      semJuros = false;
    }
    valorParcela = valorParcela.toFixed(2);
    valorTotal = valorTotal.toFixed(2);
    listaParcelas.push({
      num_parcela: parcela,
      valor_parcela: valorParcela,
      valor_total: valorTotal,
      sem_juros: semJuros,
    });
  }
  return listaParcelas;
}

// Calcula o valor da parcela para o Mercado Pago
function mpCalcParcela(valor, parcela) {
  const taxas = {
    1: 0,
    2: 5.41,
    3: 6.78,
    4: 8.25,
    5: 9.66,
    6: 11.04,
    7: 12.25,
    8: 13.85,
    9: 15.44,
    10: 16.59,
    11: 18.19,
    12: 19.79,
  };
  const taxaJuros = taxas[parcela];
  const valorJuros = (valor * taxaJuros) / 100;
  const valorParcela = (valor + valorJuros) / parcela;
  return valorParcela;
}

// Formata desconto (%)
function formataDesconto(valor) {
  valor = formatMoneyBR(valor);
  const valorArr = valor.split(',');
  if (valorArr.slice(-1)[0] == '00') {
    valor = valorArr[0];
  }
  return valor;
}

// Formata o caminho da imagem substituindo o servidor do CDN
function rpcUrlCDN(originalUrl) {
  const cdnCheckout = 'https://e692dde2776249f6.cdn.gocache.net/';
  const cdnPanel = 'https://92d408dd13ecbf07.cdn.gocache.net/';
  const findCheckout = 'https://cdn.loja.io/';
  const findPanel = 'https://app.loja.com.br/';
  if (originalUrl.includes(findPanel)) {
    return originalUrl.replace(findPanel, cdnPanel);
  }
  if (originalUrl.includes(findCheckout)) {
    return originalUrl.replace(findCheckout, cdnCheckout);
  }
  return originalUrl;
}

// Desabilita o click nos links sem url
$('body').on('click', '.slide-item[href="#"], .banner-item[href="#"]', function (ev) {
  ev.preventDefault();
});

// Executa uma função após um script ser carregado
function loadScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementById('external-js').appendChild(script);
}

// Horizontal and vertical window resize events.
(function () {
  var win = jQuery(window),
    prev_width = win.width(),
    prev_height = win.height();
  win.on('resize', function () {
    var width = win.width(),
      height = win.height();

    if (width !== prev_width) {
      win.trigger('hresize');
    }
    if (height !== prev_height) {
      win.trigger('vresize');
    }
    prev_width = width;
    prev_height = height;
  });
})();

// Converte Hexadecimal para RGBA (Para o efeito pulse na sombra)
function hexToRGBA(h, a = 1) {
  let r = 0,
    g = 0,
    b = 0;
  if (h.length == 4) {
    r = '0x' + h[1] + h[1];
    g = '0x' + h[2] + h[2];
    b = '0x' + h[3] + h[3];
  } else if (h.length == 7) {
    r = '0x' + h[1] + h[2];
    g = '0x' + h[3] + h[4];
    b = '0x' + h[5] + h[6];
  }
  return 'rgb(' + +r + ',' + +g + ',' + +b + ',' + a + ')';
}
